/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as AppAdminRouteImport } from './routes/_app.admin'
import { Route as AppChatRouteImport } from './routes/_app.chat'
import { Route as AppGespraechsauftaktRouteImport } from './routes/_app.gespraechsauftakt'
import { Route as AppHistoryRouteImport } from './routes/_app.history'
import { Route as AppNachbereitungRouteImport } from './routes/_app.nachbereitung'
import { Route as AppOnboardingRouteImport } from './routes/_app.onboarding'
import { Route as AppProdukttrainingRouteImport } from './routes/_app.produkttraining'
import { Route as AppProfileRouteImport } from './routes/_app.profile'
import { Route as AppPruefungRouteImport } from './routes/_app.pruefung'
import { Route as AppUnterlagenRouteImport } from './routes/_app.unterlagen'
import { Route as LoginIndexRouteImport } from './routes/login.index'
import { Route as LoginVerifyRouteImport } from './routes/login.verify'
import { Route as AppAdminIndexRouteImport } from './routes/_app.admin.index'
import { Route as AppAdminAuswertungRouteImport } from './routes/_app.admin.auswertung'
import { Route as AppAdminFreigabenRouteImport } from './routes/_app.admin.freigaben'
import { Route as AppAdminInhalteRouteImport } from './routes/_app.admin.inhalte'
import { Route as AppAdminMailRouteImport } from './routes/_app.admin.mail'
import { Route as AppAdminOberflaecheRouteImport } from './routes/_app.admin.oberflaeche'
import { Route as AppAdminProtokollRouteImport } from './routes/_app.admin.protokoll'
import { Route as AppAdminRollenRouteImport } from './routes/_app.admin.rollen'
import { Route as AppCoachIndexRouteImport } from './routes/_app.coach.index'
import { Route as AppCoachInhalteRouteImport } from './routes/_app.coach.inhalte'
import { Route as AppDurchlaufIndexRouteImport } from './routes/_app.durchlauf.index'
import { Route as AppDurchlaufRunIdRouteImport } from './routes/_app.durchlauf.$runId'
import { Route as AppManagementIndexRouteImport } from './routes/_app.management.index'
import { Route as AppManagementBerichteRouteImport } from './routes/_app.management.berichte'
import { Route as AppManagementInhalteRouteImport } from './routes/_app.management.inhalte'
import { Route as AppManagementTeamsRouteImport } from './routes/_app.management.teams'
import { Route as AppManagementUsersRouteImport } from './routes/_app.management.users'
import { Route as AppPlatformIndexRouteImport } from './routes/_app.platform.index'
import { Route as AppPlatformSplatRouteImport } from './routes/_app.platform.$'
import { Route as AppAdminMandantenIndexRouteImport } from './routes/_app.admin.mandanten.index'
import { Route as AppAdminMandantenIdRouteImport } from './routes/_app.admin.mandanten.$id'
import { Route as AppDurchlaufRunIdDebriefRouteImport } from './routes/_app.durchlauf.$runId_.debrief'
import { Route as AppDurchlaufRunIdReviewRouteImport } from './routes/_app.durchlauf.$runId_.review'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppChatRoute = AppChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AppRoute,
} as any)
const AppGespraechsauftaktRoute = AppGespraechsauftaktRouteImport.update({
  id: '/gespraechsauftakt',
  path: '/gespraechsauftakt',
  getParentRoute: () => AppRoute,
} as any)
const AppHistoryRoute = AppHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => AppRoute,
} as any)
const AppNachbereitungRoute = AppNachbereitungRouteImport.update({
  id: '/nachbereitung',
  path: '/nachbereitung',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingRoute = AppOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AppRoute,
} as any)
const AppProdukttrainingRoute = AppProdukttrainingRouteImport.update({
  id: '/produkttraining',
  path: '/produkttraining',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppPruefungRoute = AppPruefungRouteImport.update({
  id: '/pruefung',
  path: '/pruefung',
  getParentRoute: () => AppRoute,
} as any)
const AppUnterlagenRoute = AppUnterlagenRouteImport.update({
  id: '/unterlagen',
  path: '/unterlagen',
  getParentRoute: () => AppRoute,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginVerifyRoute = LoginVerifyRouteImport.update({
  id: '/login/verify',
  path: '/login/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAuswertungRoute = AppAdminAuswertungRouteImport.update({
  id: '/auswertung',
  path: '/auswertung',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminFreigabenRoute = AppAdminFreigabenRouteImport.update({
  id: '/freigaben',
  path: '/freigaben',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminInhalteRoute = AppAdminInhalteRouteImport.update({
  id: '/inhalte',
  path: '/inhalte',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminMailRoute = AppAdminMailRouteImport.update({
  id: '/mail',
  path: '/mail',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminOberflaecheRoute = AppAdminOberflaecheRouteImport.update({
  id: '/oberflaeche',
  path: '/oberflaeche',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminProtokollRoute = AppAdminProtokollRouteImport.update({
  id: '/protokoll',
  path: '/protokoll',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminRollenRoute = AppAdminRollenRouteImport.update({
  id: '/rollen',
  path: '/rollen',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppCoachIndexRoute = AppCoachIndexRouteImport.update({
  id: '/coach/',
  path: '/coach/',
  getParentRoute: () => AppRoute,
} as any)
const AppCoachInhalteRoute = AppCoachInhalteRouteImport.update({
  id: '/coach/inhalte',
  path: '/coach/inhalte',
  getParentRoute: () => AppRoute,
} as any)
const AppDurchlaufIndexRoute = AppDurchlaufIndexRouteImport.update({
  id: '/durchlauf/',
  path: '/durchlauf/',
  getParentRoute: () => AppRoute,
} as any)
const AppDurchlaufRunIdRoute = AppDurchlaufRunIdRouteImport.update({
  id: '/durchlauf/$runId',
  path: '/durchlauf/$runId',
  getParentRoute: () => AppRoute,
} as any)
const AppManagementIndexRoute = AppManagementIndexRouteImport.update({
  id: '/management/',
  path: '/management/',
  getParentRoute: () => AppRoute,
} as any)
const AppManagementBerichteRoute = AppManagementBerichteRouteImport.update({
  id: '/management/berichte',
  path: '/management/berichte',
  getParentRoute: () => AppRoute,
} as any)
const AppManagementInhalteRoute = AppManagementInhalteRouteImport.update({
  id: '/management/inhalte',
  path: '/management/inhalte',
  getParentRoute: () => AppRoute,
} as any)
const AppManagementTeamsRoute = AppManagementTeamsRouteImport.update({
  id: '/management/teams',
  path: '/management/teams',
  getParentRoute: () => AppRoute,
} as any)
const AppManagementUsersRoute = AppManagementUsersRouteImport.update({
  id: '/management/users',
  path: '/management/users',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformIndexRoute = AppPlatformIndexRouteImport.update({
  id: '/platform/',
  path: '/platform/',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformSplatRoute = AppPlatformSplatRouteImport.update({
  id: '/platform/$',
  path: '/platform/$',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminMandantenIndexRoute = AppAdminMandantenIndexRouteImport.update({
  id: '/mandanten/',
  path: '/mandanten/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminMandantenIdRoute = AppAdminMandantenIdRouteImport.update({
  id: '/mandanten/$id',
  path: '/mandanten/$id',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppDurchlaufRunIdDebriefRoute =
  AppDurchlaufRunIdDebriefRouteImport.update({
    id: '/durchlauf/$runId_/debrief',
    path: '/durchlauf/$runId/debrief',
    getParentRoute: () => AppRoute,
  } as any)
const AppDurchlaufRunIdReviewRoute = AppDurchlaufRunIdReviewRouteImport.update({
  id: '/durchlauf/$runId_/review',
  path: '/durchlauf/$runId/review',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/admin': typeof AppAdminRouteWithChildren
  '/chat': typeof AppChatRoute
  '/gespraechsauftakt': typeof AppGespraechsauftaktRoute
  '/history': typeof AppHistoryRoute
  '/nachbereitung': typeof AppNachbereitungRoute
  '/onboarding': typeof AppOnboardingRoute
  '/produkttraining': typeof AppProdukttrainingRoute
  '/profile': typeof AppProfileRoute
  '/pruefung': typeof AppPruefungRoute
  '/unterlagen': typeof AppUnterlagenRoute
  '/login/verify': typeof LoginVerifyRoute
  '/login/': typeof LoginIndexRoute
  '/admin/auswertung': typeof AppAdminAuswertungRoute
  '/admin/freigaben': typeof AppAdminFreigabenRoute
  '/admin/inhalte': typeof AppAdminInhalteRoute
  '/admin/mail': typeof AppAdminMailRoute
  '/admin/oberflaeche': typeof AppAdminOberflaecheRoute
  '/admin/protokoll': typeof AppAdminProtokollRoute
  '/admin/rollen': typeof AppAdminRollenRoute
  '/coach/inhalte': typeof AppCoachInhalteRoute
  '/durchlauf/$runId': typeof AppDurchlaufRunIdRoute
  '/management/berichte': typeof AppManagementBerichteRoute
  '/management/inhalte': typeof AppManagementInhalteRoute
  '/management/teams': typeof AppManagementTeamsRoute
  '/management/users': typeof AppManagementUsersRoute
  '/platform/$': typeof AppPlatformSplatRoute
  '/admin/': typeof AppAdminIndexRoute
  '/coach/': typeof AppCoachIndexRoute
  '/durchlauf/': typeof AppDurchlaufIndexRoute
  '/management/': typeof AppManagementIndexRoute
  '/platform/': typeof AppPlatformIndexRoute
  '/admin/mandanten/$id': typeof AppAdminMandantenIdRoute
  '/durchlauf/$runId/debrief': typeof AppDurchlaufRunIdDebriefRoute
  '/durchlauf/$runId/review': typeof AppDurchlaufRunIdReviewRoute
  '/admin/mandanten/': typeof AppAdminMandantenIndexRoute
}
export interface FileRoutesByTo {
  '/chat': typeof AppChatRoute
  '/gespraechsauftakt': typeof AppGespraechsauftaktRoute
  '/history': typeof AppHistoryRoute
  '/nachbereitung': typeof AppNachbereitungRoute
  '/onboarding': typeof AppOnboardingRoute
  '/produkttraining': typeof AppProdukttrainingRoute
  '/profile': typeof AppProfileRoute
  '/pruefung': typeof AppPruefungRoute
  '/unterlagen': typeof AppUnterlagenRoute
  '/login/verify': typeof LoginVerifyRoute
  '/': typeof AppIndexRoute
  '/login': typeof LoginIndexRoute
  '/admin/auswertung': typeof AppAdminAuswertungRoute
  '/admin/freigaben': typeof AppAdminFreigabenRoute
  '/admin/inhalte': typeof AppAdminInhalteRoute
  '/admin/mail': typeof AppAdminMailRoute
  '/admin/oberflaeche': typeof AppAdminOberflaecheRoute
  '/admin/protokoll': typeof AppAdminProtokollRoute
  '/admin/rollen': typeof AppAdminRollenRoute
  '/coach/inhalte': typeof AppCoachInhalteRoute
  '/durchlauf/$runId': typeof AppDurchlaufRunIdRoute
  '/management/berichte': typeof AppManagementBerichteRoute
  '/management/inhalte': typeof AppManagementInhalteRoute
  '/management/teams': typeof AppManagementTeamsRoute
  '/management/users': typeof AppManagementUsersRoute
  '/platform/$': typeof AppPlatformSplatRoute
  '/admin': typeof AppAdminIndexRoute
  '/coach': typeof AppCoachIndexRoute
  '/durchlauf': typeof AppDurchlaufIndexRoute
  '/management': typeof AppManagementIndexRoute
  '/platform': typeof AppPlatformIndexRoute
  '/admin/mandanten/$id': typeof AppAdminMandantenIdRoute
  '/durchlauf/$runId/debrief': typeof AppDurchlaufRunIdDebriefRoute
  '/durchlauf/$runId/review': typeof AppDurchlaufRunIdReviewRoute
  '/admin/mandanten': typeof AppAdminMandantenIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/_app/chat': typeof AppChatRoute
  '/_app/gespraechsauftakt': typeof AppGespraechsauftaktRoute
  '/_app/history': typeof AppHistoryRoute
  '/_app/nachbereitung': typeof AppNachbereitungRoute
  '/_app/onboarding': typeof AppOnboardingRoute
  '/_app/produkttraining': typeof AppProdukttrainingRoute
  '/_app/profile': typeof AppProfileRoute
  '/_app/pruefung': typeof AppPruefungRoute
  '/_app/unterlagen': typeof AppUnterlagenRoute
  '/login/verify': typeof LoginVerifyRoute
  '/_app/': typeof AppIndexRoute
  '/login/': typeof LoginIndexRoute
  '/_app/admin/auswertung': typeof AppAdminAuswertungRoute
  '/_app/admin/freigaben': typeof AppAdminFreigabenRoute
  '/_app/admin/inhalte': typeof AppAdminInhalteRoute
  '/_app/admin/mail': typeof AppAdminMailRoute
  '/_app/admin/oberflaeche': typeof AppAdminOberflaecheRoute
  '/_app/admin/protokoll': typeof AppAdminProtokollRoute
  '/_app/admin/rollen': typeof AppAdminRollenRoute
  '/_app/coach/inhalte': typeof AppCoachInhalteRoute
  '/_app/durchlauf/$runId': typeof AppDurchlaufRunIdRoute
  '/_app/management/berichte': typeof AppManagementBerichteRoute
  '/_app/management/inhalte': typeof AppManagementInhalteRoute
  '/_app/management/teams': typeof AppManagementTeamsRoute
  '/_app/management/users': typeof AppManagementUsersRoute
  '/_app/platform/$': typeof AppPlatformSplatRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/coach/': typeof AppCoachIndexRoute
  '/_app/durchlauf/': typeof AppDurchlaufIndexRoute
  '/_app/management/': typeof AppManagementIndexRoute
  '/_app/platform/': typeof AppPlatformIndexRoute
  '/_app/admin/mandanten/$id': typeof AppAdminMandantenIdRoute
  '/_app/durchlauf/$runId_/debrief': typeof AppDurchlaufRunIdDebriefRoute
  '/_app/durchlauf/$runId_/review': typeof AppDurchlaufRunIdReviewRoute
  '/_app/admin/mandanten/': typeof AppAdminMandantenIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/chat'
    | '/gespraechsauftakt'
    | '/history'
    | '/nachbereitung'
    | '/onboarding'
    | '/produkttraining'
    | '/profile'
    | '/pruefung'
    | '/unterlagen'
    | '/login/verify'
    | '/login/'
    | '/admin/auswertung'
    | '/admin/freigaben'
    | '/admin/inhalte'
    | '/admin/mail'
    | '/admin/oberflaeche'
    | '/admin/protokoll'
    | '/admin/rollen'
    | '/coach/inhalte'
    | '/durchlauf/$runId'
    | '/management/berichte'
    | '/management/inhalte'
    | '/management/teams'
    | '/management/users'
    | '/platform/$'
    | '/admin/'
    | '/coach/'
    | '/durchlauf/'
    | '/management/'
    | '/platform/'
    | '/admin/mandanten/$id'
    | '/durchlauf/$runId/debrief'
    | '/durchlauf/$runId/review'
    | '/admin/mandanten/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/chat'
    | '/gespraechsauftakt'
    | '/history'
    | '/nachbereitung'
    | '/onboarding'
    | '/produkttraining'
    | '/profile'
    | '/pruefung'
    | '/unterlagen'
    | '/login/verify'
    | '/'
    | '/login'
    | '/admin/auswertung'
    | '/admin/freigaben'
    | '/admin/inhalte'
    | '/admin/mail'
    | '/admin/oberflaeche'
    | '/admin/protokoll'
    | '/admin/rollen'
    | '/coach/inhalte'
    | '/durchlauf/$runId'
    | '/management/berichte'
    | '/management/inhalte'
    | '/management/teams'
    | '/management/users'
    | '/platform/$'
    | '/admin'
    | '/coach'
    | '/durchlauf'
    | '/management'
    | '/platform'
    | '/admin/mandanten/$id'
    | '/durchlauf/$runId/debrief'
    | '/durchlauf/$runId/review'
    | '/admin/mandanten'
  id:
    | '__root__'
    | '/_app'
    | '/_app/admin'
    | '/_app/chat'
    | '/_app/gespraechsauftakt'
    | '/_app/history'
    | '/_app/nachbereitung'
    | '/_app/onboarding'
    | '/_app/produkttraining'
    | '/_app/profile'
    | '/_app/pruefung'
    | '/_app/unterlagen'
    | '/login/verify'
    | '/_app/'
    | '/login/'
    | '/_app/admin/auswertung'
    | '/_app/admin/freigaben'
    | '/_app/admin/inhalte'
    | '/_app/admin/mail'
    | '/_app/admin/oberflaeche'
    | '/_app/admin/protokoll'
    | '/_app/admin/rollen'
    | '/_app/coach/inhalte'
    | '/_app/durchlauf/$runId'
    | '/_app/management/berichte'
    | '/_app/management/inhalte'
    | '/_app/management/teams'
    | '/_app/management/users'
    | '/_app/platform/$'
    | '/_app/admin/'
    | '/_app/coach/'
    | '/_app/durchlauf/'
    | '/_app/management/'
    | '/_app/platform/'
    | '/_app/admin/mandanten/$id'
    | '/_app/durchlauf/$runId_/debrief'
    | '/_app/durchlauf/$runId_/review'
    | '/_app/admin/mandanten/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginVerifyRoute: typeof LoginVerifyRoute
  LoginIndexRoute: typeof LoginIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/chat': {
      id: '/_app/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AppChatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gespraechsauftakt': {
      id: '/_app/gespraechsauftakt'
      path: '/gespraechsauftakt'
      fullPath: '/gespraechsauftakt'
      preLoaderRoute: typeof AppGespraechsauftaktRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/history': {
      id: '/_app/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof AppHistoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/nachbereitung': {
      id: '/_app/nachbereitung'
      path: '/nachbereitung'
      fullPath: '/nachbereitung'
      preLoaderRoute: typeof AppNachbereitungRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding': {
      id: '/_app/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AppOnboardingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/produkttraining': {
      id: '/_app/produkttraining'
      path: '/produkttraining'
      fullPath: '/produkttraining'
      preLoaderRoute: typeof AppProdukttrainingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pruefung': {
      id: '/_app/pruefung'
      path: '/pruefung'
      fullPath: '/pruefung'
      preLoaderRoute: typeof AppPruefungRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/unterlagen': {
      id: '/_app/unterlagen'
      path: '/unterlagen'
      fullPath: '/unterlagen'
      preLoaderRoute: typeof AppUnterlagenRouteImport
      parentRoute: typeof AppRoute
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/verify': {
      id: '/login/verify'
      path: '/login/verify'
      fullPath: '/login/verify'
      preLoaderRoute: typeof LoginVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/auswertung': {
      id: '/_app/admin/auswertung'
      path: '/auswertung'
      fullPath: '/admin/auswertung'
      preLoaderRoute: typeof AppAdminAuswertungRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/freigaben': {
      id: '/_app/admin/freigaben'
      path: '/freigaben'
      fullPath: '/admin/freigaben'
      preLoaderRoute: typeof AppAdminFreigabenRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/inhalte': {
      id: '/_app/admin/inhalte'
      path: '/inhalte'
      fullPath: '/admin/inhalte'
      preLoaderRoute: typeof AppAdminInhalteRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/mail': {
      id: '/_app/admin/mail'
      path: '/mail'
      fullPath: '/admin/mail'
      preLoaderRoute: typeof AppAdminMailRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/oberflaeche': {
      id: '/_app/admin/oberflaeche'
      path: '/oberflaeche'
      fullPath: '/admin/oberflaeche'
      preLoaderRoute: typeof AppAdminOberflaecheRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/protokoll': {
      id: '/_app/admin/protokoll'
      path: '/protokoll'
      fullPath: '/admin/protokoll'
      preLoaderRoute: typeof AppAdminProtokollRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/rollen': {
      id: '/_app/admin/rollen'
      path: '/rollen'
      fullPath: '/admin/rollen'
      preLoaderRoute: typeof AppAdminRollenRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/coach/': {
      id: '/_app/coach/'
      path: '/coach'
      fullPath: '/coach/'
      preLoaderRoute: typeof AppCoachIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/coach/inhalte': {
      id: '/_app/coach/inhalte'
      path: '/coach/inhalte'
      fullPath: '/coach/inhalte'
      preLoaderRoute: typeof AppCoachInhalteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/durchlauf/': {
      id: '/_app/durchlauf/'
      path: '/durchlauf'
      fullPath: '/durchlauf/'
      preLoaderRoute: typeof AppDurchlaufIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/durchlauf/$runId': {
      id: '/_app/durchlauf/$runId'
      path: '/durchlauf/$runId'
      fullPath: '/durchlauf/$runId'
      preLoaderRoute: typeof AppDurchlaufRunIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/management/': {
      id: '/_app/management/'
      path: '/management'
      fullPath: '/management/'
      preLoaderRoute: typeof AppManagementIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/management/berichte': {
      id: '/_app/management/berichte'
      path: '/management/berichte'
      fullPath: '/management/berichte'
      preLoaderRoute: typeof AppManagementBerichteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/management/inhalte': {
      id: '/_app/management/inhalte'
      path: '/management/inhalte'
      fullPath: '/management/inhalte'
      preLoaderRoute: typeof AppManagementInhalteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/management/teams': {
      id: '/_app/management/teams'
      path: '/management/teams'
      fullPath: '/management/teams'
      preLoaderRoute: typeof AppManagementTeamsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/management/users': {
      id: '/_app/management/users'
      path: '/management/users'
      fullPath: '/management/users'
      preLoaderRoute: typeof AppManagementUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/': {
      id: '/_app/platform/'
      path: '/platform'
      fullPath: '/platform/'
      preLoaderRoute: typeof AppPlatformIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/$': {
      id: '/_app/platform/$'
      path: '/platform/$'
      fullPath: '/platform/$'
      preLoaderRoute: typeof AppPlatformSplatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/mandanten/': {
      id: '/_app/admin/mandanten/'
      path: '/mandanten'
      fullPath: '/admin/mandanten/'
      preLoaderRoute: typeof AppAdminMandantenIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/mandanten/$id': {
      id: '/_app/admin/mandanten/$id'
      path: '/mandanten/$id'
      fullPath: '/admin/mandanten/$id'
      preLoaderRoute: typeof AppAdminMandantenIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/durchlauf/$runId_/debrief': {
      id: '/_app/durchlauf/$runId_/debrief'
      path: '/durchlauf/$runId/debrief'
      fullPath: '/durchlauf/$runId/debrief'
      preLoaderRoute: typeof AppDurchlaufRunIdDebriefRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/durchlauf/$runId_/review': {
      id: '/_app/durchlauf/$runId_/review'
      path: '/durchlauf/$runId/review'
      fullPath: '/durchlauf/$runId/review'
      preLoaderRoute: typeof AppDurchlaufRunIdReviewRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppAdminRouteChildren {
  AppAdminAuswertungRoute: typeof AppAdminAuswertungRoute
  AppAdminFreigabenRoute: typeof AppAdminFreigabenRoute
  AppAdminInhalteRoute: typeof AppAdminInhalteRoute
  AppAdminMailRoute: typeof AppAdminMailRoute
  AppAdminOberflaecheRoute: typeof AppAdminOberflaecheRoute
  AppAdminProtokollRoute: typeof AppAdminProtokollRoute
  AppAdminRollenRoute: typeof AppAdminRollenRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppAdminMandantenIdRoute: typeof AppAdminMandantenIdRoute
  AppAdminMandantenIndexRoute: typeof AppAdminMandantenIndexRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminAuswertungRoute: AppAdminAuswertungRoute,
  AppAdminFreigabenRoute: AppAdminFreigabenRoute,
  AppAdminInhalteRoute: AppAdminInhalteRoute,
  AppAdminMailRoute: AppAdminMailRoute,
  AppAdminOberflaecheRoute: AppAdminOberflaecheRoute,
  AppAdminProtokollRoute: AppAdminProtokollRoute,
  AppAdminRollenRoute: AppAdminRollenRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppAdminMandantenIdRoute: AppAdminMandantenIdRoute,
  AppAdminMandantenIndexRoute: AppAdminMandantenIndexRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppChatRoute: typeof AppChatRoute
  AppGespraechsauftaktRoute: typeof AppGespraechsauftaktRoute
  AppHistoryRoute: typeof AppHistoryRoute
  AppNachbereitungRoute: typeof AppNachbereitungRoute
  AppOnboardingRoute: typeof AppOnboardingRoute
  AppProdukttrainingRoute: typeof AppProdukttrainingRoute
  AppProfileRoute: typeof AppProfileRoute
  AppPruefungRoute: typeof AppPruefungRoute
  AppUnterlagenRoute: typeof AppUnterlagenRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCoachInhalteRoute: typeof AppCoachInhalteRoute
  AppDurchlaufRunIdRoute: typeof AppDurchlaufRunIdRoute
  AppManagementBerichteRoute: typeof AppManagementBerichteRoute
  AppManagementInhalteRoute: typeof AppManagementInhalteRoute
  AppManagementTeamsRoute: typeof AppManagementTeamsRoute
  AppManagementUsersRoute: typeof AppManagementUsersRoute
  AppPlatformSplatRoute: typeof AppPlatformSplatRoute
  AppCoachIndexRoute: typeof AppCoachIndexRoute
  AppDurchlaufIndexRoute: typeof AppDurchlaufIndexRoute
  AppManagementIndexRoute: typeof AppManagementIndexRoute
  AppPlatformIndexRoute: typeof AppPlatformIndexRoute
  AppDurchlaufRunIdDebriefRoute: typeof AppDurchlaufRunIdDebriefRoute
  AppDurchlaufRunIdReviewRoute: typeof AppDurchlaufRunIdReviewRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRouteWithChildren,
  AppChatRoute: AppChatRoute,
  AppGespraechsauftaktRoute: AppGespraechsauftaktRoute,
  AppHistoryRoute: AppHistoryRoute,
  AppNachbereitungRoute: AppNachbereitungRoute,
  AppOnboardingRoute: AppOnboardingRoute,
  AppProdukttrainingRoute: AppProdukttrainingRoute,
  AppProfileRoute: AppProfileRoute,
  AppPruefungRoute: AppPruefungRoute,
  AppUnterlagenRoute: AppUnterlagenRoute,
  AppIndexRoute: AppIndexRoute,
  AppCoachInhalteRoute: AppCoachInhalteRoute,
  AppDurchlaufRunIdRoute: AppDurchlaufRunIdRoute,
  AppManagementBerichteRoute: AppManagementBerichteRoute,
  AppManagementInhalteRoute: AppManagementInhalteRoute,
  AppManagementTeamsRoute: AppManagementTeamsRoute,
  AppManagementUsersRoute: AppManagementUsersRoute,
  AppPlatformSplatRoute: AppPlatformSplatRoute,
  AppCoachIndexRoute: AppCoachIndexRoute,
  AppDurchlaufIndexRoute: AppDurchlaufIndexRoute,
  AppManagementIndexRoute: AppManagementIndexRoute,
  AppPlatformIndexRoute: AppPlatformIndexRoute,
  AppDurchlaufRunIdDebriefRoute: AppDurchlaufRunIdDebriefRoute,
  AppDurchlaufRunIdReviewRoute: AppDurchlaufRunIdReviewRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginVerifyRoute: LoginVerifyRoute,
  LoginIndexRoute: LoginIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
